import { Component, inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { EventViewModel } from '../../../../models-views/event.view.model';
import { AppCommon } from '../../../../providers/app-common';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-cet-payment-modal',
  standalone: false,
  templateUrl: './cet-payment-modal.component.html',
  styleUrl: './cet-payment-modal.component.scss'
})
export class CetPaymentModalComponent {
  loading:boolean = false
  loadMsg:string = 'Creating payment...'
  payment:any
  form: FormGroup;
  loggedInUser :any
  fileList: NzUploadFile[] = []
  invoices = [ ];
  paymentMethods = [
            {id:'BANK_TRANSFER',name :'Bank Transfer' } ,
            {id:'CREDIT_CARD',name :'Credit Card' } ,
            {id:'CHEQUE',name :'Cheque' } ,
            {id:'CASH',name :'Cash' } ,
            {id:'OTHER',name :'Other' } 
              ]
  users = [ ];

  constructor(private vm: EventViewModel, private route: ActivatedRoute,
    private fb: FormBuilder, private modalRef: NzModalRef, private message: NzMessageService,) {
   this.vm.cetPaymentModalComponent = this
   this.loggedInUser = AppCommon.getloggedInObject().user
   this.payment = inject(NZ_MODAL_DATA);
   this.initForm()
   if(this.payment?.data){
    this.updateForm()
   }
   this.vm.userList.subscribe( e => this.users = e.results );
   this.vm.invoiceResponseModel.subscribe( e => this.invoices = e.results );
   this.vm.getInvoices(1,500,'cetPaymentsComponent')
   this.vm.getUserList(1,500);
  }

  initForm(){
    this.form = this.fb.group({
      payment_date: [null, [Validators.required]],
      amount_paid: [null, [Validators.required]],
      payment_method: [null, [Validators.required]],
      transaction_id: [null],
      notes: [null],
      invoice: [null, [Validators.required]],
      recorded_by: [null],
      file:[[]]
    });
  }

  updateForm(){
    let data = {
      payment_date: this.payment.data.payment_date,
      amount_paid: this.payment.data.amount_paid ,
      payment_method: this.payment.data.payment_method ,
      transaction_id: this.payment.data.transaction_id ,
      notes: this.payment.data.notes ,
      invoice: this.payment.data.invoice ,
      recorded_by: this.payment.data.recorded_by ,
      file: this.payment.data.file
    }
    this.form.patchValue(data)
    this.fileList = this.payment.data.file_details.map(file => ({
        uid: file.id,
        name: this.getFileName(file.file_url),
        status: 'done',
        url: `${environment.api_url}${file.file_url}`
      }))
  }

   getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }

  handleModalCancel(): void {
    this.form.reset();
    this.loading = false
    this.modalRef.close(true);
  }

  onSubmit(): void {
    if (this.form.valid) {
      console.log('Form submitted:', this.form.value);
      let d = this.form.value
      if(this.payment?.data){
        d.id = this.payment.data.id
        d.modified_by = this.loggedInUser.id
        this.loadMsg = 'Updating payment...'
        this.loading = true
        this.vm.updatePaymentById(d)
      } else{
        this.loading = true
        d.created_by = this.loggedInUser.id
        this.vm.createPayments(d)
      }
      
      
    } else {
      console.warn('Form invalid');
    }
  }


  
  customUploadRequest = (item: any) => {
   return  this.vm.uploadMediaFile(item, this.loggedInUser.id)
  };

  onUploadChange(event: any): void {
    // console.log('Upload Event:', event);
    if (event.type === 'success') {
      this.form.get('file')?.setValue( [...this.form.get('file').value ,event.file.response.id], { emitEvent: false });
      console.log('File uploaded successfully:', event.file);
    } else if (event.type === 'error') {
      console.error('File upload failed:', event.file);
    } else if(event.type == 'removed'){ 
      this.fileList = this.fileList.filter(f => f.uid !== event.file.uid);
      this.form.get('file')?.setValue( [...this.fileList ], { emitEvent: false });
      // this.vmt.deleteMediaFile(event.file.uid)
    }
    
    
  }

   beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> => 
      new Observable((observer: Observer<boolean>) => {
          const isLt5M = file.size! / 1024 / 1024 < 5;
          if (!isLt5M) {
              this.message.error(`${file.name} is larger than 5MB!`);
              observer.next(false); // Emit false to indicate validation failed
              observer.complete();
          } else {
              observer.next(true); // Emit true to indicate validation passed
              observer.complete();
          }
      });
  

}
